/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});


	$(".team-button").each(function(){

		$(this).on('click', function(){
			if($(this).prev().hasClass('open')){
				$(this).prev().removeClass('open')
				$(this).children().first().html('Read More')
				$(this).children().last().removeClass('open')
			} else{
				$(this).prev().addClass('open')
				$(this).children().first().html('Read Less')
				$(this).children().last().addClass('open')
			}
			
		})
	  });


	  let headerBtn = $('.header__btn');
	  let headerLinks = $('.header__links');
	  let header = $('.header');
	  headerBtn.click(function (e) {
		  e.preventDefault();
		  headerLinks.toggleClass('open');
		  headerBtn.toggleClass('open');
		  header.toggleClass('open');

	  });





	$(window).scroll(function() {

		var sticky = $('header'),
		scroll = $(window).scrollTop();

		if (scroll >= 200) $('.header').addClass('fixed');
		else $('.header').removeClass('fixed');

		var backToTop = $('.back-to-top')
		if (scroll >= 200) backToTop.addClass('open');
		else backToTop.removeClass('open');

		var windowBottom = $(this).scrollTop() + $(this).innerHeight();


		

		$(".anim-heading").each(function() {
			/* Check the location of each desired element */
			var objectBottom = $(this).offset().top + $(this).outerHeight();
			
			/* If the element is completely within bounds of the window, fade it in */
			if ((objectBottom-200) < windowBottom) { 
			  $(this).addClass('open')
			}

			if((objectBottom-200) > windowBottom) {
				$(this).removeClass('open')
			}
		});
		
		

	  }).scroll();


	  $(".anim-heading-contact").each(function() {

		  $(this).addClass('open')
	});

	$(".showonopen").each(function() {

		$(this).addClass('open')
  });

	//   $(window).scroll(function() {
	// 	var theta = ($(window).scrollTop() % Math.PI)*100;
	// 	$('#particles-js').css({ transform: 'rotate(' + theta + 'rad)' });
	//   });
	$(document).ready(function(){
		var bodyHeight = $("body").height()-$(window).height();
		window.onscroll = function() {
	 
		   //Determine the amount to rotate by.
		   var deg = -window.scrollY*(360/bodyHeight);
	 
		   var vh = $(window).height();
		//    console.log(vh)

		//    console.log(scrollY)
		   $("#particles-js5").css({
			
			 "transform": "rotate(" +((deg/7)*(-1)) + "deg) scale("+( 1 +(scrollY/bodyHeight/8 ))+")",
		   });

		   

		   $("#particles-js3").css({
			
			"transform": "rotate(" +((deg/30)*(-1)) + "deg) scale("+( 1 +(scrollY/bodyHeight/6))+")",
		  });

		  $("#particles-js4").css({
			
			"transform": "rotate(" +((deg/30)*(-1)) + "deg) scale("+( 1 +(scrollY/bodyHeight/12))+")",
		  });

		//    if((scrollY) > (vh/3)){
		// 	$("#particles-js5").addClass('moveright')
		//    } else {
		// 	$("#particles-js5").removeClass('moveright')
		//    }

		   

		if((scrollY) > (vh/2)){
				$("#particles-js2").css({
			
				"transform": "rotate(" +((deg/6)*(1)) + "deg)",
	
			  });	 
		} 
		};
	 });



	$("#arrow2").click(function() {
		$([document.documentElement, document.body]).animate({
			scrollTop: $("#sec2").offset().top
		}, 100);
	});

	$("#arrow3").click(function() {
		$([document.documentElement, document.body]).animate({
			scrollTop: $("#sec4").offset().top
		}, 100);
	});

	$("#arrow4").click(function() {
		$([document.documentElement, document.body]).animate({
			scrollTop: $("#sec21").offset().top
		}, 100);
	});

	$("#arrow5").click(function() {
		$([document.documentElement, document.body]).animate({
			scrollTop: $("#sec22").offset().top
		}, 100);
	});

	$("#arrow6").click(function() {
		$([document.documentElement, document.body]).animate({
			scrollTop: $("#sec3").offset().top
		}, 100);
	});

	  $(document).ready(function(){
		$('.carousel').slick({
		  dots: true,
		  infinite: true,
		  speed: 500,
		  fade: true,
		  arrows: true,
		  cssEase: 'linear',
		  autoplay: true,
		  autoplaySpeed: 2000,
		});
	});

	$(document).ready(function(){
		$('.blog-carousel').slick({
		dots: true,
		  infinite: true,
		  speed: 500,
		  slidesToShow: 3,
			slidesToScroll: 3,
			arrows: false,
		 	 cssEase: 'linear',
		  	autoplay: true,
		  	autoplaySpeed: 8000,
			  responsive: [
				{
				  breakpoint: 767,
				  settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
			
				  }
				}
				// You can unslick at a given breakpoint now by adding:
				// settings: "unslick"
				// instead of a settings object
			 ]
		});
	});

}); 

// let card = document.querySelector(".cart");

// window.addEventListener("scroll", () => {
//   var top = window.pageYOffset / 10;
//   card.style.transform = 'rotate3d(0.2, 0.2, 0.1, ' + top + 'deg)';
// });


function scrollTo(hash) {
    location.hash = "#" + hash;
}


